// Embroidery cart sync: keeps embroidery addon quantity in sync with main products that have Monogram.
// Loaded globally from theme.liquid when settings.embroidery_product is set, as we need cart functionality site-wide.

function syncEmbroideryQuantities() {
  if (!window.theme.embroideryConfig?.variantId) return;

  // Get cart drawer or cart page element
  const cart = document.querySelector('cart-drawer') || document.querySelector('[data-cart-page]');

  // Add loading class immediately to keep cart in loading state
  if (cart) {
    cart.classList.add('is-loading');
  }

  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      // Count products that have Monogram property (products with embroidery)
      const productsWithEmbroidery = cartData.items.filter(item =>
        item.variant_id != window.theme.embroideryConfig?.variantId &&
        item.properties?.Monogram &&
        item.properties.Monogram.trim() !== ''
      );

      const totalEmbroideryNeeded = productsWithEmbroidery.reduce(
        (sum, item) => sum + item.quantity,
        0
      );

      // Find the single embroidery line item
      const embroideryItem = cartData.items.find(item =>
        item.variant_id == window.theme.embroideryConfig?.variantId
      );

      let needsUpdate = false;
      const updates = {};

      if (totalEmbroideryNeeded === 0) {
        // No products need embroidery, remove embroidery item if it exists
        if (embroideryItem) {
          updates[embroideryItem.key] = 0;
          needsUpdate = true;
        }
      } else if (embroideryItem) {
        // Embroidery item exists, update quantity if needed
        if (embroideryItem.quantity !== totalEmbroideryNeeded) {
          updates[embroideryItem.key] = totalEmbroideryNeeded;
          needsUpdate = true;
        }
      } else {
        // Embroidery item doesn't exist but is needed - add it
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: window.theme.embroideryConfig?.variantId,
            quantity: totalEmbroideryNeeded
          })
        })
        .then(response => response.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        });
      }

      if (needsUpdate) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
      } else {
        // No updates needed, remove loading class
        if (cart) {
          cart.classList.remove('is-loading');
        }
      }
    })
    .then(response => {
      if (response) {
        return response.json();
      }
    })
    .then(data => {
      if (data) {
        // Trigger full cart refresh to update subtotal
        // This is necessary because the subtotal calculation happens in getCart()
        // The loading class will be removed by the build() function
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      }
    })
    .catch(error => {
      console.error('Error syncing embroidery quantities:', error);
      // Remove loading class on error
      if (cart) {
        cart.classList.remove('is-loading');
      }
    });
}

// Listen for products being added to cart
document.addEventListener('theme:product:added', function(e) {
  // Check if the added item has the Monogram property (product with embroidery)
  const item = e.detail?.item || {};
  const hasEmbroidery = item.properties?.Monogram && item.properties.Monogram.trim() !== '';

  if (hasEmbroidery) {
    syncEmbroideryQuantities();
  }
});

// Listen for the theme's cart update event (fired by quantity-counter component and remove buttons)
document.addEventListener('theme:cart:update', function(e) {
  // Check if the updated item is a main product with embroidery
  // For quantity changes: e.target is the cart item element
  // For remove clicks: e.detail.item is provided
  const cartItem = e.detail?.item ? e.detail.item : (typeof e?.target.closest === 'function' ? e?.target.closest('[data-item]') : null);
  const hasEmbroidery = cartItem?.hasAttribute('data-has-embroidery');

  // Only sync if this specific item has embroidery
  if (!hasEmbroidery) {
    return;
  }

  // Listen for the next theme:product:added event which fires after cart rebuild completes
  document.addEventListener('theme:product:added', function() {
    // Now sync embroidery quantities after cart has been fully rebuilt
    syncEmbroideryQuantities();
  }, { once: true });
});
